import { Button, DialogActions } from '@mui/material';
import type React from 'react';
import { useTranslation } from 'react-i18next';

type TransferFilesDialogActionsProps = {
	onClose: () => void;
	onTransfer: () => void;
	isPending: boolean;
	selectedCount: number;
};

export function TransferFilesDialogActions({
	onClose,
	onTransfer,
	isPending,
	selectedCount,
}: TransferFilesDialogActionsProps): React.JSX.Element {
	const { t } = useTranslation(['commonButton', 'unitOverview']);

	return (
		<DialogActions>
			<Button variant="outlined" onClick={onClose} disabled={isPending}>
				{t('commonButton:cancel')}
			</Button>
			<Button
				color="secondary"
				variant="contained"
				disabled={selectedCount === 0 || isPending}
				onClick={onTransfer}>
				{t('unitOverview:transfer-file')}
			</Button>
		</DialogActions>
	);
}
